import {
  BusinessUnit,
  UniversalBuSpecificContent,
  UniversalConfigurationGroup,
  UniversalDesignObligation,
  UniversalInformation,
  UniversalMaturityLevelSequence,
  UniversalMaturityLevelSet,
  UniversalOperator,
  UniversalTailoringCriterion,
} from '@/gql/graphql';

import { UniversalBuildingBlock, UniversalCompetency, UniversalDataBlock, UniversalMaturityStage } from '@/gql/graphql';

export type UPMNode =
  | UniversalDesignObligation
  | UniversalMaturityStage
  | UniversalCompetency
  | UniversalInformation
  | BusinessUnit
  | UniversalConfigurationGroup
  | UniversalTailoringCriterion
  | UniversalBuildingBlock
  | UniversalDataBlock
  | UniversalBuSpecificContent
  | UniversalOperator
  | UniversalMaturityLevelSet
  | UniversalMaturityLevelSequence;

export enum UPMNodeEnum {
  Unpublished = 'unpublished',
  Unconnected = 'unconnected',
  DataBlock = 'db',
  DesignObligation = 'do',
  BuildingBlock = 'bb',
  MaturityStages = 'mts',
  Competencies = 'co',
  Information = 'inf',
  BusinessUnits = 'bu',
  Configuration = 'cfg',
  TailroingCriteria = 'tc',
  BuSpecificContent = 'buc',
  Operator = 'op',
  MaturityLevelSet = 'mls',
  MaturityLevelSequence = 'mlsq',
}
